import { Modal } from "@mantine/core";
import dynamic   from "next/dynamic";

import { useGetDarkMode } from "_common/hooks/global";
import Icon               from "_components/atoms/icon";
import Loader             from "_components/atoms/loader";
import ModalHeader        from "_components/molecules/modalHeader";
import UploadStatusModal  from "_components/organisms/uploadVideo/components/uploadStatusModal";
import ProfileHeader      from "_components/templates/userProfileHeader";
import useStyles          from "_styles/pages/userProfile";

import UserProfileTabs from "./userProfileTabs";

const ModeratorsTab = dynamic ( () => import ( "_components/features/chat/management/components/moderatorsTab" ), { ssr: false } );

const ErrorModalModerators = ( {
	toggleErrorModal,
	toggleModeratorModal
} ) => {

	const { classes } = useStyles ( undefined, { name: "styles" } );
	const darkMode    = useGetDarkMode ();

	return (
		<div className = { classes.errorModalWrapper }>
			<Icon
				sameInBothTheme
				className = { darkMode ? classes.crossButtonInvert : classes.crossButton }
				name      = "seachBarCross"
				onClick   = { toggleErrorModal }
				size      = { "40px" }
			/>

			<Icon sameInBothTheme
				className = { classes.errorIcon }
				name      = "accountDetailsError"
				size      = { "80px" }
			/>

			<div className = { classes.text1 }>Maximum Limit Reached</div>

			<div>You have selected all 10/10 moderators.</div>

			<div
				className = { classes.marginBottom }
			>
				Remove the existing ones to add a new one.
			</div>

			<button
				className = { classes.manageButton }
				onClick   = { () => {
					toggleModeratorModal ();
					toggleErrorModal ();
				} }
			>
				Manage Moderators
			</button>

		</div>
	);
};
const component = props => {
	const {
		userId,
		userProfile,
		// ugcStats,
		userBroadcastDetails,
		isModerator,
		showModeratorModal,
		toggleModeratorModal,
		toggleModeratorOption,
		errorModal,
		toggleErrorModal,
		activeTab,
		activeTabData
	} = props;

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<>
			<div className = { classes.userProfileWrapper }>
				{
					userProfile && userBroadcastDetails
						? (
							<ProfileHeader
								activeTab              = { activeTab }
								isModerator            = { isModerator }
								toggleErrorModal       = { toggleErrorModal }
								toggleModeratorOption  = { toggleModeratorOption }
								userBroadcasterDetails = { userBroadcastDetails }
								userId                 = { userId }
								userProfile            = { userProfile }
							/>
						) : (
							<Loader />
						)

				}

				<UserProfileTabs
					activeTab     = { activeTab }
					activeTabData = { activeTabData }
					userId        = { userId }
				/>

			</div>

			{
				showModeratorModal && (
					<Modal
						centered
						disableAutoFocus
						onClose         = { toggleModeratorModal }
						opened          = { showModeratorModal }
						radius          = "lg"
						size            = "auto"
						styles          = { { body: { padding: "0" }, content: { background: "none" } } }
						withCloseButton = { false }
					>
						<div className = { classes.moderatorModalWrapper }>

							<ModalHeader
								onClose = { toggleModeratorModal }
								title   = "Manage Moderators"
							/>

							<ModeratorsTab
								isInUserProfile = { false }
							/>

						</div>

					</Modal>
				)

			}

			{
				errorModal && (
					<Modal
						centered
						disableAutoFocus
						onClose         = { toggleModeratorModal }
						opened          = { errorModal }
						radius          = "lg"
						size            = "xl"
						styles          = { { body: { padding: "0" }, content: { background: "none" } } }
						withCloseButton = { false }
					>
						<ErrorModalModerators
							toggleErrorModal     = { toggleErrorModal }
							toggleModeratorModal = { toggleModeratorModal }
						/>

					</Modal>
				)
			}

			<UploadStatusModal />
		</>
	);
};

export default component;
